// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkspaceMembersPopup__search-d51eef {
  margin: 16px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/WorkspaceMembersPopup/WorkspaceMembersPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF","sourcesContent":[".search {\n  margin: 16px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `WorkspaceMembersPopup__search-d51eef`
};
module.exports = ___CSS_LOADER_EXPORT___;
